import { MaterialType } from "@/pages/Warehouse/pages/InventoryManage/components/MaterialDetail";
import request, { AxiosResponseBody } from ".";
import { CommonListParams } from "@/types/common";
import { ChangeEnum, ConfirmedEnum } from "@/types/inventory";
import { InventoryLotItem, InventoryLocationItem, InventoryV2, ItemBarcode, WLocation, AddLocation, OrderV2, AddItemLocation, OrderItemLocation, OrderAddItemV2, OrderAddV2, UpdataOrderLot, CountAddProps, CountRes, CountOrder, CountAddItem, LocationLot, MoveLocationProps, InventoryOrderItemCountUpdateReqDto, OrderItemV2, LocationRefProduct, InventoryWithLPL, InventoryWithLPLParam, IQCOrder, QCTypeEnum, QCStateEnum, AddIQCOrder, AddIQCItem, QCItem, OrderItemSpecialData, SpecialHandlingConfirm, OrderItemLocationDtl } from "@/types/inventoryV2";
import { Product } from "@/types/product";
import { DictLike, DictLikeNumberKey } from "@/types/dict";
import { PackOrder } from "@/types/packing";

const url = '/wms/v2/inventory';
const qcUrl = '/wms/v2/inventory/qc';

const apis = {
  // 库存
  list: url + '/list',
  realList: url + '/real/list',
  lotProLocList: url + '/lot/product/locations',
  itemList: (isPur: boolean) => `${url}/order${isPur ? '/purchased' : ''}/item/list`,
  itemFetch: (id: string) => `${url}/order/item/${id}/fetch`,
  orderSpecialHandling: (id: string) => `${url}/order/${id}/specialHandling/list`,
  locationList: (type?: number) => `${url}/location${type === undefined ? "" : '/' + type}/list`,
  productLots: (proId: string) => url + `/${proId}/lots`,
  productLocations: (proId: string) => url + `/${proId}/locations`,

  productSpecLots: (proId: string) => url + `/${proId}/specialized/lots`,
  productSpecLocations: (proId: string) => url + `/${proId}/specialized/locations`,

  // 库位
  locationFetch: (locId: string) => url + `/location/${locId}/fetch`,
  locationLots: (locationId: string) => url + `/location/${locationId}/lots`,
  addLocation: url + '/location/add',
  updateLocation: (locId: string) => url + `/location/${locId}/update`,
  locationTypes: url + `/location/types`,

  //条码
  inventoryBarcodes: (inventoryId: string) => url + `/${inventoryId}/barcodes`,
  locationBarcodes: (locationId: string) => url + `/location/${locationId}/barcodes`,

  //订单
  orderAdd: url + '/order/add',
  orderLotUpdate: (id: string) => url + `/order/item/${id}/lot/update`,
  orderDescUpdate: (id: string) => url + `/order/${id}/desc/update`,
  orderArrivalAtUpdate: (id: string) => url + `/order/${id}/arrivalAt/update`,
  orderPreOut: (id: string) => url + `/order/${id}/preOut`,
  orderList: (confirmed?: ConfirmedEnum) => url + `/order/${confirmed !== undefined ? confirmed + '/' : ''}list`,
  orderFetch: (id: string) => url + `/order/${id}/fetch`,
  orderPackOrders: `${url}/order/packOrders`,
  orderItemUpdate: (id: string) => url + `/order/item/${id}/update`,
  orderItemCountUpdates: url + '/order/item/count/updates',  // 批量更新订单项数量

  //入库
  itemLocationRms: (itemId: string) => url + `/order/item/${itemId}/location/rms`,
  addItemlocation: (itemId: string) => url + `/order/item/${itemId}/location/adds`,
  orderConfirm: (orderId: string, forced: 0 | 1) => url + `/order/${orderId}/force/${forced}/confirm`,
  orderArrival: (orderId: string) => url + `/order/${orderId}/arrivalAt/update`,


  orderDel: (orderId: string) => url + `/order/${orderId}/del`,

  // 专用料列表
  specList: url + '/specialized/list',

  //盘点
  countList: url + '/counting/order/list',
  countFetch: (id: string) => `${url}/counting/order/${id}/fetch`,
  countAdd: url + '/counting/order/add',
  countDiff: (id: string) => `${url}/counting/order/${id}/diff`,
  countDo: (id: string, noLot: number) => `${url}/counting/order/${id}/${noLot}/do`,

  countItemAdds: (id: string) => `${url}/counting/order/${id}/item/adds`,
  countItemRms: (id: string) => `${url}/counting/order/${id}/item/rms`,
  countDel: (id: string) => `${url}/counting/order/${id}/del`,

  //移库
  fetchLot: (id: string) => `${url}/lot/${id}/fetch`,
  moveLocation: (sourceId: string, targetId: string) => `${url}/location/lot/${sourceId}/move/${targetId}`,

  // orderV2
  orderItemRms: (orderId: string) => url + `/order/${orderId}/item/rms`,
  orderItemAdds: (id: string) => `${url}/order/${id}/item/adds`,

  //locationRefProduct
  locProdRefList: `${url}/location/product-relation/list`,
  locProdRefDels: `${url}/location/product-relation/dels`,
  locRefProdList: (id: string) => `${url}/location/location/${id}/products`,
  locRefProds: (id: string) => `${url}/location/location/${id}/products/adds`,

  // 产品推介库位
  productRefLocations: (id: string) => `${url}/location/product/${id}/locations`,
  locationRefProducts: (id: string) => `${url}/location/location/${id}/products`,
  //QC质检
  qcList: `${qcUrl}/order/list`,
  qcFetch: (id: string) => `${qcUrl}/order/${id}/fetch`,
  inventoryQcList: (id: string) => `${qcUrl}/order/order/${id}/list`,
  addQcOrder: `${qcUrl}/order/add`,
  qcItemUpdate: (id: string) => `${qcUrl}/order/item/${id}/update`,
  qcDone: (id: string) => `${qcUrl}/order/${id}/complete`,
  inventoryQcState: (id: string) => `${url}/order/${id}/iqcState/update`,

  // 打印
  orderPrint: (id: string) => `${url}/order/${id}/print`,
  orderQcPrint: (id: string) => `${url}/order/${id}/qc/print`,

  //库位出入库明细
  itemLocList: `${url}/order/item/location/list`,
  itemLocApi: `${url}/item/location/list`,
}

export interface InventoryListParam {
  keyword?: string;
  ids?: string[];
  category?: string;
  locationTypes?: number[];
}
export const list = (params: CommonListParams<InventoryListParam>) => {
  return new Promise<CommonListParams<Array<InventoryV2>>>((resolve, reject) => {
    request<Array<InventoryV2>, InventoryListParam>(apis.list, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const realList = (params: CommonListParams<InventoryListParam>) => {
  return new Promise<CommonListParams<Array<InventoryV2>>>((resolve, reject) => {
    request<Array<InventoryV2>, InventoryListParam>(apis.realList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const lotProLocList = (datas: Array<InventoryWithLPLParam>) => {
  return new Promise<Array<InventoryWithLPL>>((resolve, reject) => {
    request<Array<InventoryWithLPL>, Array<InventoryWithLPLParam>>(apis.lotProLocList, { params: { body: datas } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export interface ItemListParams {
  keyword?: string;
  confirmState?: ConfirmedEnum;
  orderTypes?: Array<ChangeEnum>;
  products?: Array<string>;
  arrivalAtStart?: number;
  arrivalAtEnd?: number;
  createdStartAt?: number;
  createdEndAt?: number;
}

export const itemList = (params: CommonListParams<ItemListParams>, isPur: boolean) => {
  let paramsTemp = { ...params };
  if (!!paramsTemp.body?.keyword) {
    let kwArr = paramsTemp.body.keyword.trim().split(' ');
    if (kwArr.length > 1) {
      paramsTemp.body.products = [...kwArr]
      delete paramsTemp.body.keyword
    }
  }
  return new Promise<CommonListParams<Array<OrderItemV2>>>((resolve, reject) => {
    request<Array<OrderItemV2>, ItemListParams>(apis.itemList(isPur), { params: paramsTemp })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const itemFetch = (id: string) => {
  return new Promise<OrderItemV2>((resolve, reject) => {
    request<OrderItemV2, string>(apis.itemFetch(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderSpecialHandling = (params: CommonListParams | undefined, orderId: string) => {
  return new Promise<AxiosResponseBody<Array<OrderItemSpecialData>>>((resolve, reject) => {
    request<Array<OrderItemSpecialData>, string>(apis.orderSpecialHandling(orderId), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const locationList = (params: CommonListParams, type?: number) => {
  return new Promise<CommonListParams<Array<WLocation>>>((resolve, reject) => {
    request<Array<WLocation>, string>(apis.locationList(type), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const productLots = (proId: string, type: MaterialType, params: CommonListParams) => {
  return new Promise<CommonListParams<Array<InventoryLotItem>>>((resolve, reject) => {
    request<Array<InventoryLotItem>, string>(type === "COMMON" ? apis.productLots(proId) : apis.productSpecLots(proId), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};


export const productLocations = (proId: string, type: MaterialType, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<InventoryLocationItem>>>((resolve, reject) => {
    request<Array<InventoryLocationItem>, string>(type === "COMMON" ? apis.productLocations(proId) : apis.productSpecLocations(proId), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const locationFetch = (locId: string) => {
  return new Promise<WLocation>((resolve, reject) => {
    request<WLocation, string>(apis.locationFetch(locId))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

// export const locationLots = (locationId: string, params: CommonListParams) => {
//   return new Promise<CommonListParams<Array<InventoryLotItem>>>((resolve, reject) => {
//     request<Array<InventoryLotItem>, string>(apis.locationLots(locationId), { params })

//       .then((res) => resolve(res))
//       .catch((err) => reject(err));
//   })
// };

export const addLocation = (data: AddLocation) => {
  return new Promise<WLocation>((resolve, reject) => {
    request<WLocation, AddLocation>(apis.addLocation, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const updateLocation = (locId: string, data: AddLocation) => {
  return new Promise<WLocation>((resolve, reject) => {
    request<WLocation, AddLocation>(apis.updateLocation(locId), { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};
export const locationTypes = () => {
  return new Promise<DictLikeNumberKey[]>((resolve, reject) => {
    request<DictLikeNumberKey[], undefined>(apis.locationTypes)
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};


export const inventoryBarcodes = (inventoryId: string, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ItemBarcode>>>((resolve, reject) => {
    request<Array<ItemBarcode>, string>(apis.inventoryBarcodes(inventoryId), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const locationBarcodes = (inventoryId: string, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ItemBarcode>>>((resolve, reject) => {
    request<Array<ItemBarcode>, string>(apis.locationBarcodes(inventoryId), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const orderAdd = (data: OrderAddV2) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, OrderAddV2>(apis.orderAdd, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderLotUpdate = (id: string, data: UpdataOrderLot) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, UpdataOrderLot>(apis.orderLotUpdate(id), { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderDescUpdate = (id: string, data: string) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, string>(apis.orderDescUpdate(id), { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderArrivalAtUpdate = (id: string, data: number) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, number>(apis.orderArrivalAtUpdate(id), { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderPreOut = (id: string, locationTypes: number[]) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2>(apis.orderPreOut(id), { params: { ints: locationTypes } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderList = (params: CommonListParams, orgId: string, confirmed?: ConfirmedEnum) => {
  return new Promise<CommonListParams<Array<OrderV2>>>((resolve, reject) => {
    request<Array<OrderV2>, string>(apis.orderList(confirmed), { params, requestConfig: { headers: { org_id: orgId } } })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};


export const orderFetch = (id: string) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, string>(apis.orderFetch(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

// 按出库单 数组ID  反查关联装箱单，按装箱单 ID 去重；空入参返回空列表。
export const orderPackOrders = (body: string[], controller?: AbortController) => {
  return new Promise<PackOrder[]>((resolve, reject) => {
    request<PackOrder[], string[]>(apis.orderPackOrders, { params: { body }, controller })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const itemLocationRms = (itemId: string, locIds: Array<string>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, Array<string>>(apis.itemLocationRms(itemId), { params: { body: locIds } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const addItemlocation = (itemId: string, locations: Array<AddItemLocation>) => {
  return new Promise<Array<OrderItemLocation>>((resolve, reject) => {
    request<Array<OrderItemLocation>, Array<AddItemLocation>>(apis.addItemlocation(itemId), { params: { body: locations } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const orderConfirm = (orderId: string, forced: 0 | 1, body?: SpecialHandlingConfirm[]) => {
  return new Promise<void>((resolve, reject) => {
    request<void, boolean | SpecialHandlingConfirm[]>(apis.orderConfirm(orderId, forced), { params: { body } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const orderArrival = (orderId: string, arrivalAt: number) => {
  return new Promise<void>((resolve, reject) => {
    request<void, number>(apis.orderArrival(orderId), { params: { body: arrivalAt } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const orderDel = (orderId: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void>(apis.orderDel(orderId))
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const specList = (params: CommonListParams) => {
  return new Promise<CommonListParams<Array<InventoryV2>>>((resolve, reject) => {
    request<Array<InventoryV2>, string>(apis.specList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const countList = (params: CommonListParams) => {
  return new Promise<CommonListParams<Array<CountOrder>>>((resolve, reject) => {
    request<Array<CountOrder>, string>(apis.countList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const countFetch = (id: string) => {
  return new Promise<CountOrder>((resolve, reject) => {
    request<CountOrder>(apis.countFetch(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err))
  })
}

export const countAdd = (data: CountAddProps) => {
  return new Promise<CountOrder>((resolve, reject) => {
    request<CountOrder, CountAddProps>(apis.countAdd, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err))
  })
}

export const countDiff = (id: string) => {
  return new Promise<Array<CountRes>>((resolve, reject) => {
    request<Array<CountRes>>(apis.countDiff(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err))
  })
}

export const countDo = (id: string, noLot?: 0 | 1) => {
  return new Promise<CountOrder>((resolve, reject) => {
    request<CountOrder>(apis.countDo(id, noLot || 0))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err))
  })
}

export const countItemAdds = (id: string, data: Array<CountAddItem>) => {
  return new Promise<CountOrder>((resolve, reject) => {
    request<CountOrder, Array<CountAddItem>>(apis.countItemAdds(id), { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err))
  })
}
export const countItemRms = (id: string, ids: Array<string>) => {
  return new Promise<CountOrder>((resolve, reject) => {
    request<CountOrder, Array<string>>(apis.countItemRms(id), { params: { body: ids } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err))
  })
}

export const countDel = (countId: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void>(apis.countDel(countId))
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const fetchLot = (id: string) => {
  return new Promise<LocationLot>((resolve, reject) => {
    request<LocationLot, string>(apis.fetchLot(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const moveLocation = (sourceId: string, targetId: string, data: Array<MoveLocationProps>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, Array<MoveLocationProps>>(apis.moveLocation(sourceId, targetId), {
      params: { body: data }
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};


export const orderItemRms = (orderId: string, itemIds: Array<string>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, Array<string>>(apis.orderItemRms(orderId), { params: { body: itemIds } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const orderItemAdds = (id: string, datas: Array<OrderAddItemV2>) => {
  return new Promise<Array<OrderItemV2>>((resolve, reject) => {
    request<Array<OrderItemV2>, Array<OrderAddItemV2>>(apis.orderItemAdds(id), { params: { body: datas } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};
// V2 订单项更新请求接口
export interface OrderItemUpdateDto {
  productId: string;
  count: number;
  sourceId: string;
  sourceType?: number;
  lot?: string;
  thdLot?: string;
}

// V2 更新订单项
export const orderItemUpdate = (id: string, itemData: OrderItemUpdateDto) => {


  if (!id || (typeof id !== 'string')) {
    return Promise.reject(10012);
  }

  if (!itemData.productId || typeof itemData.count !== 'number') {
    return Promise.reject(10012);
  }


  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, OrderItemUpdateDto>(apis.orderItemUpdate(id), {
      params: { body: itemData }
    })
      .then((res) => {
        resolve(res.body);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 支持多个订单类型的列表查询
export const orderListV2 = ({ orgId, keyword, params, confirmed, controller }: {
  orgId: string;
  keyword?: string;
  params?: {
    body?: string;
    ints?: number[];
    pagination?: {
      offset: number;
      take: number;
    };
    startTime?: number;
    endTime?: number;
  };
  confirmed?: ConfirmedEnum
  controller?: AbortController;
}) => {

  if (!orgId) {
    return Promise.reject(10012);
  }

  const requestParams: any = {
    requestConfig: {
      headers: { org_id: orgId }
    }
  };

  if (params) {
    requestParams.params = params;
  }

  // ✅ 传递 controller 用于取消请求
  if (controller) {
    requestParams.controller = controller;
  }

  return new Promise<CommonListParams<Array<OrderV2>>>((resolve, reject) => {
    request<Array<OrderV2>, string>(apis.orderList(confirmed), requestParams)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 批量更新订单项数量
export const orderItemCountUpdates = (items: Array<InventoryOrderItemCountUpdateReqDto>) => {

  if (!Array.isArray(items) || items.length === 0) {
    console.error('更新项列表不能为空');
    return Promise.reject(10012);
  }

  // 验证每个项的数据
  for (const item of items) {
    if (!item.orderItemId || typeof item.count !== 'number') {
      return Promise.reject(10012);
    }
  }


  return new Promise<Array<OrderItemV2>>((resolve, reject) => {
    request<Array<OrderItemV2>, Array<InventoryOrderItemCountUpdateReqDto>>(apis.orderItemCountUpdates, {
      params: { body: items }
    })
      .then((res) => {
        resolve(res.body);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const locProdRefList = (params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<LocationRefProduct>>>((resolve, reject) => {
    request<Array<LocationRefProduct>, string | undefined>(apis.locProdRefList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
}

export const locProdRefDels = (ids: Array<string>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string[]>(apis.locProdRefDels, { params: { body: ids } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
}
export const locRefProdList = (locId: string, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<Product>>>((resolve, reject) => {
    request<Array<Product>, string | undefined>(apis.locRefProdList(locId), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
}

export const locRefProds = (locId: string, proIds: string[]) => {
  return new Promise<Array<LocationRefProduct>>((resolve, reject) => {
    request<Array<LocationRefProduct>, Array<string>>(apis.locRefProds(locId), { params: { body: proIds } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
}

export const productRefLocations = (proId: string) => {
  return new Promise<Array<WLocation>>(
    (resolve, reject) => {
      request<Array<WLocation>, string>(apis.productRefLocations(proId))
        .then(res => resolve(res.body))
        .catch(err => reject(err));
    }
  );
};

export const locationRefProducts = (locId: string) => {
  return new Promise<Array<Product>>(
    (resolve, reject) => {
      request<Array<Product>, string>(apis.locationRefProducts(locId))
        .then(res => resolve(res.body))
        .catch(err => reject(err));
    }
  );
};
export interface QcListBody {
  keyword?: string;
  qcTypes?: Array<QCTypeEnum>;
  qcStates?: Array<QCStateEnum>;
}
export const qcList = (params: CommonListParams<QcListBody>) => {
  return new Promise<CommonListParams<Array<IQCOrder>>>((resolve, reject) => {
    request<Array<IQCOrder>, QcListBody>(apis.qcList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const qcFetch = (id: string) => {
  return new Promise<IQCOrder>((resolve, reject) => {
    request<IQCOrder, undefined>(apis.qcFetch(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const inventoryQcList = (params: CommonListParams<QcListBody>, id: string) => {
  return new Promise<CommonListParams<Array<IQCOrder>>>((resolve, reject) => {
    request<Array<IQCOrder>, QcListBody>(apis.inventoryQcList(id), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const addQcOrder = (data: AddIQCOrder) => {
  return new Promise<IQCOrder>((resolve, reject) => {
    request<IQCOrder, AddIQCOrder>(apis.addQcOrder, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const qcItemUpdate = (id: string, data: AddIQCItem) => {
  return new Promise<void>((resolve, reject) => {
    request<void, AddIQCItem>(apis.qcItemUpdate(id), { params: { body: data } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const qcDone = (id: string) => {
  return new Promise<IQCOrder>((resolve, reject) => {
    request<IQCOrder, undefined>(apis.qcDone(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const inventoryQcState = (id: string, state: QCStateEnum) => {
  return new Promise<void>((resolve, reject) => {
    request<void, QCStateEnum>(apis.inventoryQcState(id), { params: { body: state } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderPrint = (id: string, fileId: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string>(apis.orderPrint(id), { params: { body: fileId } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderQcPrint = (id: string, fileId: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string>(apis.orderQcPrint(id), { params: { body: fileId } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export interface ItemLocListParamBody {
  lots?: string[];
  products?: string[];
  locationType?: number;
  keyword?: string;
  confirmState?: ConfirmedEnum;
  orderTypes?: Array<ChangeEnum>;
  arrivalAtStart?: number;
  arrivalAtEnd?: number;
  createdStartAt?: number;
  createdEndAt?: number;
};
export const itemLocList = (params?: CommonListParams<ItemLocListParamBody>) => {
  return new Promise<AxiosResponseBody<Array<OrderItemLocationDtl>>>((resolve, reject) => {
    request<Array<OrderItemLocationDtl>, ItemLocListParamBody>(apis.itemLocList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};
export interface ItemLocParamBody {
  lots?: string[];
  productIds?: string[];
  locationTypes?: number[];
};
export const itemLocApi = (params?: CommonListParams<ItemLocParamBody>) => {
  return new Promise<AxiosResponseBody<Array<InventoryLocationItem>>>((resolve, reject) => {
    request<Array<InventoryLocationItem>, ItemLocParamBody>(apis.itemLocApi, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};
